import { WA_NUMBER } from './products'

export interface Combo {
  id: number
  name: string
  products: string[]
  comboPrice: number
  individualPrice: number
  savings: number
  image: string
  pain: string
  benefit: string
  waMessage: string
}

export const combos: Combo[] = [
  {
    id: 1,
    name: 'Combo Fuerza + Masa',
    products: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    comboPrice: 1690,
    individualPrice: 2290,
    savings: 600,
    image:
      'https://cdn.magicpatterns.com/uploads/g2gkabWXWwXzgMAADaGtf5/Isolate_protein_mix_y_creatine_powder.jpg',
    pain: 'El atleta que quiere ganar músculo y fuerza pero gasta de más comprando cada suplemento por separado.',
    benefit:
      'Proteína de alta calidad + creatina pura en un solo combo económico para crecer más rápido.',
    waMessage:
      'Hola! Quiero el Combo Fuerza + Masa — Isolate Protein Mix 900g + Creatine POWER 300g por $1.690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 2,
    name: 'Combo Volumen Total',
    products: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine 100% Pure 250g (Profit)',
      'Vaso Shaker 750ml (Profit)',
    ],
    comboPrice: 2290,
    individualPrice: 2890,
    savings: 600,
    image:
      'https://cdn.magicpatterns.com/uploads/wcaSN7P9sHv9huJ2y6WQ3g/Anabolic_y_Creatine_100_pure.jpg',
    pain: 'El hardgainer que no puede subir de peso sin importar cuánto come o entrena.',
    benefit:
      'El stack completo para ganar masa muscular real, con el shaker incluido para prepararlo en cualquier momento.',
    waMessage:
      'Hola! Quiero el Combo Volumen Total — Anabolic MASS 28500 3kg + Creatine 100% Pure 250g + Vaso Shaker 750ml por $2.290 UY. ¿Tienen stock disponible?',
  },
  {
    id: 3,
    name: 'Combo Masa + Potencia',
    products: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine POWER 300g (Profit)',
      'Vaso Shaker 750ml (Profit)',
    ],
    comboPrice: 1990,
    individualPrice: 2490,
    savings: 500,
    image:
      'https://cdn.magicpatterns.com/uploads/n3Z3JS1Ba1NW8xRvB1rGQx/Isolate_protein_mix_y_creatine_power.jpg',
    pain: 'Querés ganar volumen muscular y potencia explosiva pero no podés costear ambos suplementos por separado.',
    benefit:
      'Calorías de calidad + creatina potente + shaker incluido. Todo lo que necesitás para explotar en el gym.',
    waMessage:
      'Hola! Quiero el Combo Masa + Potencia — Anabolic MASS 28500 3kg + Creatine POWER 300g + Vaso Shaker 750ml por $1.990 UY. ¿Tienen stock disponible?',
  },
  {
    id: 4,
    name: 'Combo Alpha Cibeles',
    products: [
      'Power Whey Protein 2LB (Cibeles)',
      'Creatina CREAPURE Cibeles 350g (Cibeles)',
    ],
    comboPrice: 4690,
    individualPrice: 5890,
    savings: 1200,
    image:
      'https://cdn.magicpatterns.com/uploads/fEGGn5T6NCa8fNJWctvSec/Whey_protein_y_creatina_350g.jpg',
    pain: 'Querés los mejores suplementos del mercado uruguayo pero el precio individual te frena.',
    benefit:
      'La combinación más poderosa de proteína + creatina certificada CREAPURE para resultados visibles en semanas.',
    waMessage:
      'Hola! Quiero el Combo Alpha Cibeles — Power Whey Protein 2LB + Creatina CREAPURE Cibeles 350g por $4.690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 5,
    name: 'Combo Masa + Creatina',
    products: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    comboPrice: 1790,
    individualPrice: 2590,
    savings: 800,
    image:
      'https://cdn.magicpatterns.com/uploads/cmh1V2TfazNJ6qCDbNRVdm/Anabolic_Mass_3kg_2B_Creatine_POWER_300g.jpg',
    pain: 'Querés ganar masa muscular y potenciar tu fuerza pero comprar cada suplemento por separado se va de presupuesto.',
    benefit:
      'Hipercalórico de alta calidad + creatina potente para ganar volumen y fuerza en un solo combo accesible.',
    waMessage:
      'Hola! Quiero el Combo Masa + Creatina — Anabolic MASS 28500 3kg + Creatine POWER 300g por $1.790 UY. ¿Tienen stock disponible?',
  },
  {
    id: 6,
    name: 'Combo Whey + Creatina Cibeles',
    products: [
      'Whey Protein Cibeles 2LB (Cibeles)',
      'Creatina CREAPURE Cibeles 150g (Cibeles)',
    ],
    comboPrice: 3190,
    individualPrice: 3990,
    savings: 800,
    image:
      'https://cdn.magicpatterns.com/uploads/qFwoWnTnBGEoRyjtNP2xVk/Whey_Protein_2lb_2B_Creatina_Cibeles_150g.jpg',
    pain: 'Querés empezar con suplementos de calidad Cibeles pero el precio de ambos juntos te frena.',
    benefit:
      'Proteína Whey + creatina CREAPURE certificada en formato accesible. La base perfecta para empezar a ver resultados.',
    waMessage:
      'Hola! Quiero el Combo Whey + Creatina Cibeles — Whey Protein 2LB + Creatina CREAPURE 150g por $3.190 UY. ¿Tienen stock disponible?',
  },
  {
    id: 7,
    name: 'Combo Definición Total',
    products: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
      'Pro Abdomen 60 Caps (Profit)',
    ],
    comboPrice: 2090,
    individualPrice: 2590,
    savings: 500,
    image:
      'https://cdn.magicpatterns.com/uploads/w4t68R7iTURZ63PtmY88qT/Isolate_2B_Creatine_2B_Pro_abdomen.jpg',
    pain: 'Querés definir tu físico, ganar fuerza y quemar grasa abdominal pero armar el stack completo te sale caro.',
    benefit:
      'Proteína + creatina + termogénico en un solo combo. Todo lo que necesitás para definir y rendir al máximo.',
    waMessage:
      'Hola! Quiero el Combo Definición Total — Isolate Protein Mix 900g + Creatine POWER 300g + Pro Abdomen 60 Caps por $2.090 UY. ¿Tienen stock disponible?',
  },
  {
    id: 8,
    name: 'Combo Power + Creatina Cibeles',
    products: [
      'Power Whey Protein Isolate 2LB (Cibeles)',
      'Creatina CREAPURE Cibeles 150g (Cibeles)',
    ],
    comboPrice: 3790,
    individualPrice: 4690,
    savings: 900,
    image:
      'https://cdn.magicpatterns.com/uploads/5yDWr8q9NmFtUK9yavoPhQ/Power_Whey_Protein_2LB_2B_Creatine_Creapure_150g.jpg',
    pain: 'Querés la proteína más pura del mercado con creatina certificada pero el precio individual te limita.',
    benefit:
      'Proteína Isolate premium + creatina CREAPURE en formato accesible. El combo élite para resultados serios.',
    waMessage:
      'Hola! Quiero el Combo Power + Creatina Cibeles — Power Whey Protein Isolate 2LB + Creatina CREAPURE 150g por $3.790 UY. ¿Tienen stock disponible?',
  },
]
